import { useEffect, useState } from "react";

import "./addPositionSelect.scss";

const isSparePartsProduct = (position) =>
    [
        position?.is_spare_parts,
        position?.is_spare_part,
        position?.spare_parts,
        position?.product?.is_spare_parts,
        position?.product?.is_spare_part,
        position?.product?.spare_parts,
    ].some((value) => +value === 1 || value === true || value === "true");

const AddPositionSelect = ({ orderPositions, addPositionHandler, positions }) => {
    const [orderPositionsList, setOrderPositionsList] = useState([]);

    useEffect(() => {
        const positionsIds = positions.map((position) => position.id);
        if (orderPositions) {
            setOrderPositionsList([
                ...orderPositions.products.filter((product) => !positionsIds.includes(product.id)),
                ...orderPositions.services.filter((service) => !positionsIds.includes(service.id)),
            ]);
        }
    }, [orderPositions, positions]);

    return (
        <>
            {orderPositionsList && (
                <div className="select-container ">
                    <div className="overflow-scroll" style={{ height: "300px" }}>
                        <ul className="list-group">
                            {orderPositionsList.map((position) => {
                                return (
                                    <button
                                        key={position.id + position.title}
                                        type="button"
                                        className="list-group-item list-group-item-action"
                                        onClick={() => addPositionHandler(position)}
                                    >
                                        <div className="d-flex align-items-center gap-1 flex-wrap">
                                            {position.title}
                                            {position.imei_sn
                                                ? ` (${position.imei_sn.slice(position.imei_sn.length - 5)})`
                                                : ""}
                                            {isSparePartsProduct(position) && (
                                                <span className="badge bg-danger ms-1">
                                                    Товар списаний на запчастини
                                                </span>
                                            )}
                                        </div>
                                        <div>
                                            <span className="text-primary">{position.price} грн.</span>{" "}
                                            {position.store ? (
                                                <span className="text-warning fw-bold">{position.store.title}</span>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </button>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddPositionSelect;
